import React, { useState, useRef, useEffect} from 'react';
// import { Wave } from "@foobar404/wave";
import styles from '../Vol1.module.css'; 
import { shuffle } from 'lodash';  // make sure lodash is installed
import { useNavigate } from 'react-router-dom';
import { getAudioUrl, getImageUrl } from '../services/r2Service';
import { FaPlay, FaPause, FaForward, FaBackward, FaRandom, FaRedo } from 'react-icons/fa';

interface Song {
    audioFile: string;
    coverImage: string;
    title: string;
}

interface Vol2Props {
    searchTerm: string;
    setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

const songs: Song[] = [
    { 
        audioFile: getAudioUrl('megapackv2/Love 02.11.22.mp3'),
        coverImage: getImageUrl('love.png'),
        title: 'Love' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/Searching 05.06.22.mp3'),
        coverImage: getImageUrl('searching.png'),
        title: 'Searching' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/The Butcher 04.28.22.mp3'),
        coverImage: getImageUrl('thebutcher.png'),
        title: 'The Butcher' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/Victory Lap 02.25.21_2.mp3'),
        coverImage: getImageUrl('victorylap.png'),
        title: 'Victory Lap' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/memory lane 02.25.21.mp3'),
        coverImage: getImageUrl('memorylane.png'),
        title: 'Memory Lane' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/my first sample 05.28.20.mp3'),
        coverImage: getImageUrl('myfirstsample.png'),
        title: 'My First Sample' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/neon scampy 01.03.20.mp3'),
        coverImage: getImageUrl('neonscampy.png'),
        title: 'Neon Scampy' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/no i cant 05.30.21.mp3'),
        coverImage: getImageUrl('noicant.png'),
        title: 'No I Can\'t' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/notepad 08.17.20.mp3'),
        coverImage: getImageUrl('notepad.png'),
        title: 'Notepad' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/oh why 05.08.21.mp3'),
        coverImage: getImageUrl('ohwhy.png'),
        title: 'Oh Why' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/pattio 08.15,20.mp3'),
        coverImage: getImageUrl('pattio.png'),
        title: 'Pattio' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/power 01.12.20.mp3'),
        coverImage: getImageUrl('power.png'),
        title: 'Power' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/real reason 11.18.20.mp3'),
        coverImage: getImageUrl('realreason.png'),
        title: 'Real Reason' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/rrollin 05.02.21.mp3'),
        coverImage: getImageUrl('rrollin.png'),
        title: 'Rrolin' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/soundblock 09.20.20.mp3'),
        coverImage: getImageUrl('soundblock.png'),
        title: 'Soundblock' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/stay a little longer 10.25.20.mp3'),
        coverImage: getImageUrl('stayalittlelonger.png'),
        title: 'Stay A Little Longer' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/the lop basement 05.21.20.mp3'),
        coverImage: getImageUrl('lopsbasement.png'),
        title: 'The Lop\'s Basement' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/triumph 05.05.21.mp3'),
        coverImage: getImageUrl('triumph.png'),
        title: 'Triumph' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/truman 08.22.20_2.mp3'),
        coverImage: getImageUrl('truman.png'),
        title: 'Truman' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/western 11.01.20.mp3'),
        coverImage: getImageUrl('western.png'),
        title: 'Western' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/work 08.02.20.mp3'),
        coverImage: getImageUrl('work.png'),
        title: 'Work' 
    },
    { 
        audioFile: getAudioUrl('megapackv2/yin and yang 08.01.21.mp3'),
        coverImage: getImageUrl('yinandyang.png'),
        title: 'Yin and Yang' 
    }
];

const Vol2: React.FC<Vol2Props> = ({ searchTerm, setSearchTerm }) => {
    const audioRef = useRef<HTMLAudioElement>(new Audio());
    const [currentSongIndex, setCurrentSongIndex] = useState(0);
    const [volume, setVolume] = useState(0.5);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [filteredSongs, setFilteredSongs] = useState(songs);
    const [isPlaying, setIsPlaying] = useState(false);
    const [repeat, setRepeat] = useState(false);
    const [shuffleEnabled, setShuffleEnabled] = useState(false);
    const [shuffledSongs, setShuffledSongs] = useState(songs);
    const [isImageLoading, setIsImageLoading] = useState(false);
    const navigate = useNavigate();
    const prevImageUrlRef = useRef<string | null>(null);

    const handleNextTapeClick = () => {
        navigate('/Vol3');
    };

    const handlePrevTapeClick = () => {
        navigate('/Vol1');
    };

    const handleShuffle = () => {
        const audioElement = audioRef.current;
        const currentSong = shuffleEnabled ? shuffledSongs[currentSongIndex] : filteredSongs[currentSongIndex];
        const currentSongIndexInFiltered = filteredSongs.findIndex(song => song.title === currentSong.title);
        const currentPlaybackTime = audioElement.currentTime;

        if (shuffleEnabled) {
            setShuffledSongs(filteredSongs);
            setCurrentSongIndex(currentSongIndexInFiltered);
        } else {
            const upcomingSongs = shuffle(filteredSongs.filter((_, index) => index !== currentSongIndexInFiltered));
            setShuffledSongs([currentSong, ...upcomingSongs]);
            setCurrentSongIndex(0);
        }
        setShuffleEnabled(!shuffleEnabled);
        setRepeat(false);

        setTimeout(() => {
            audioElement.currentTime = currentPlaybackTime;
            if (isPlaying) audioElement.play().catch(() => {});
        }, 0);
    };

    const handleRepeat = () => {
        const audioElement = audioRef.current;
        const currentSongs = shuffleEnabled ? shuffledSongs : filteredSongs;
        const currentSong = currentSongs[currentSongIndex];
        const currentSongIndexInFiltered = filteredSongs.findIndex(song => song.title === currentSong.title);
        const currentPlaybackTime = audioElement.currentTime;

        setRepeat(!repeat);
        setShuffleEnabled(false);
        setShuffledSongs(filteredSongs);
        setCurrentSongIndex(currentSongIndexInFiltered);

        setTimeout(() => {
            audioElement.currentTime = currentPlaybackTime;
            if (isPlaying) audioElement.play().catch(() => {});
        }, 0);
    };

    const handleSongEnd = () => {
        if (repeat) {
            audioRef.current.currentTime = 0;
            audioRef.current.play();
        } else {
            const nextIndex = (currentSongIndex + 1) % (shuffleEnabled ? shuffledSongs.length : filteredSongs.length);
            setCurrentSongIndex(nextIndex);
        }
    };

    useEffect(() => {
        audioRef.current.addEventListener('ended', handleSongEnd);

        return () => {
            audioRef.current.removeEventListener('ended', handleSongEnd);
        };
    }, [repeat, shuffleEnabled, currentSongIndex]);

    useEffect(() => {
        const audioElement = audioRef.current;

        const handleLoadedMetadata = () => {
            setDuration(audioElement.duration);
        };

        const handleTimeUpdate = () => {
            setCurrentTime(audioElement.currentTime);
        };

        audioElement.addEventListener('loadedmetadata', handleLoadedMetadata);
        audioElement.addEventListener('timeupdate', handleTimeUpdate);

        return () => {
            audioElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
            audioElement.removeEventListener('timeupdate', handleTimeUpdate);
        };
    }, []);

    useEffect(() => {
        const currentSongs = shuffleEnabled ? shuffledSongs : filteredSongs;
        const audioElement = audioRef.current;

        if (currentSongs.length > 0 && audioElement.src !== currentSongs[currentSongIndex].audioFile) {
            audioElement.src = currentSongs[currentSongIndex].audioFile;
            if (!shuffleEnabled) {
                audioElement.currentTime = 0;
            }
            if (isPlaying) {
                audioElement.play().catch(() => {});
            }
        } else if (currentSongs.length === 0) {
            // Stop playback and reset when no songs are available
            audioElement.pause();
            audioElement.currentTime = 0;
            setIsPlaying(false);
        }
    }, [currentSongIndex, shuffleEnabled, filteredSongs, shuffledSongs]);

    useEffect(() => {
        if (searchTerm === '') {
            setFilteredSongs(songs);
            setShuffledSongs(songs);
        } else {
            const filtered = songs.filter(song => song.title.toLowerCase().includes(searchTerm.toLowerCase()));
            setFilteredSongs(filtered);
            setShuffledSongs(filtered);
        }
        setCurrentSongIndex(0);
    }, [searchTerm]);

    useEffect(() => {
        return () => {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        };
    }, []);

    const formatTime = (time: number) => {
        const floorTime = Math.floor(time);
        const minutes = Math.floor(floorTime / 60);
        const seconds = '0' + (floorTime - minutes * 60);
        return minutes + ':' + seconds.substr(-2);
    };

    const handleTogglePlay = () => {
        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    const handleVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newVolume = parseFloat(e.target.value);
        setVolume(newVolume);
        audioRef.current.volume = newVolume;
    };

    const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newTime = parseFloat(e.target.value);
        setCurrentTime(newTime);
        audioRef.current.currentTime = newTime;
    };

    const changeSong = (delta: number) => {
        const currentSongs = shuffleEnabled ? shuffledSongs : filteredSongs;
        const nextIndex = (currentSongIndex + delta + currentSongs.length) % currentSongs.length;
        setCurrentSongIndex(nextIndex);
    };

    const selectSong = (title: string) => {
        const index = filteredSongs.findIndex(song => song.title === title);
        if (index > -1) {
            setCurrentSongIndex(index);
            setIsPlaying(true);
            audioRef.current.play().catch(() => {});
        }
    };

    useEffect(() => {
        const currentSongs = shuffleEnabled ? shuffledSongs : filteredSongs;
        const currentSong = currentSongs[currentSongIndex];
        const currentImageUrl = currentSong?.coverImage;

        if (prevImageUrlRef.current !== currentImageUrl) {
            setIsImageLoading(true);
            prevImageUrlRef.current = currentImageUrl;
        }
    }, [currentSongIndex, shuffleEnabled, filteredSongs, shuffledSongs]);

    return (
        <div className={styles.container}>
            <h1 className={styles.volumeTitle}>Volume 2</h1>
            <input
                className={styles['search-bar']}
                type='text'
                placeholder='Search for a song...'
                value={searchTerm}
                onChange={event => setSearchTerm(event.target.value)}
            />
            <div className={styles.albumCoverContainer}>
                {filteredSongs.length > 0 ? (
                    <img 
                        src={shuffleEnabled ? shuffledSongs[currentSongIndex]?.coverImage : filteredSongs[currentSongIndex]?.coverImage} 
                        alt='Cover' 
                        className={`${styles.albumCover} ${isImageLoading ? styles.loading : ''}`}
                        onLoad={() => setIsImageLoading(false)}
                    />
                ) : (
                    <img 
                        src={getImageUrl('nophoto.jpg')} 
                        alt='No Results' 
                        className={styles.albumCover}
                    />
                )}
            </div>

            <div className={styles.audioControls}>
                <button onClick={handleShuffle} className={styles.button} title={shuffleEnabled ? 'Disable Shuffle' : 'Enable Shuffle'} disabled={filteredSongs.length === 0}>
                    <FaRandom className={shuffleEnabled ? styles.activeIcon : styles.icon} />
                </button>
                <button onClick={() => changeSong(-1)} className={styles.button} title="Previous" disabled={filteredSongs.length === 0}>
                    <FaBackward className={styles.icon} />
                </button>
                <button onClick={handleTogglePlay} className={`${styles.button} ${styles.playButton}`} title={isPlaying ? 'Pause' : 'Play'} disabled={filteredSongs.length === 0}>
                    {isPlaying ? <FaPause className={styles.icon} /> : <FaPlay className={styles.icon} />}
                </button>
                <button onClick={() => changeSong(1)} className={styles.button} title="Next" disabled={filteredSongs.length === 0}>
                    <FaForward className={styles.icon} />
                </button>
                <button onClick={handleRepeat} className={styles.button} title={repeat ? 'Disable Repeat' : 'Enable Repeat'} disabled={filteredSongs.length === 0}>
                    <FaRedo className={repeat ? styles.activeIcon : styles.icon} />
                </button>
            </div>

            <div className={styles.playerControls}>
                <div className={styles.trackTitle}>
                    {filteredSongs.length > 0 
                        ? (shuffleEnabled ? shuffledSongs[currentSongIndex]?.title : filteredSongs[currentSongIndex]?.title)
                        : 'No songs found'}
                </div>
                <div className={styles.timeControls}>
                    <div className={styles.timeRow}>
                        <span className={styles.timeText}>{formatTime(currentTime)}</span>
                        <input
                            type="range"
                            min="0"
                            max={duration}
                            value={currentTime}
                            onChange={handleTimeChange}
                            className={styles.timeSlider}
                            disabled={filteredSongs.length === 0}
                        />
                        <span className={styles.timeTextRight}>{formatTime(duration)}</span>
                    </div>
                </div>
                <div className={styles.volumeSliderWrapper}>
                    <input
                        type="range"
                        min="0"
                        max="1"
                        step="0.01"
                        value={volume}
                        onChange={handleVolumeChange}
                        className={styles.volumeSlider}
                    />
                </div>
                <div className={styles.volumeText}>Volume</div>
                <div style={{ height: '2rem' }} />
                <div className={styles.tapeControls}>
                    <button onClick={handleNextTapeClick}>Next Tape</button>
                    <button onClick={handlePrevTapeClick}>Previous Tape</button>
                </div>
            </div>

            <div className={styles.tracklist}>
                <h2 className={styles.tracklistLabel}>Tracklist</h2>
                {filteredSongs.length > 0 ? (
                    filteredSongs.map(song => (
                        <div key={song.title} className={styles.tracklistItem} onClick={() => selectSong(song.title)}>
                            {song.title}
                        </div>
                    ))
                ) : (
                    <p className={styles.tracklistLabel}>No songs match your search.</p>
                )}
            </div>
        </div>
    );
};

export default Vol2;
